import { Navigate, useSearchParams } from 'react-router-dom';
import { PHYSICS_LAB_PATH, physicsLabYear } from './physicsLabNavigation';

/** Catalogue launch route keeps Study visibility gates and opens the independent workspace. */
export function PhysicsLabStudyEntry() {
  const [params] = useSearchParams();
  const search = new URLSearchParams({ from: 'physics' });
  const year = physicsLabYear(params.get('year')) ?? 'all';
  search.set('year', year);
  return <Navigate to={`${PHYSICS_LAB_PATH}?${search}`} replace />;
}
